import { render, staticRenderFns } from "./MainPlanner2.vue?vue&type=template&id=011237fa&scoped=true&"
import script from "./MainPlanner2.vue?vue&type=script&lang=js&"
export * from "./MainPlanner2.vue?vue&type=script&lang=js&"
import style0 from "./MainPlanner2.vue?vue&type=style&index=0&id=011237fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011237fa",
  null
  
)

export default component.exports